/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  DatePicker,
  Alert,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import API from 'utils/api';
import { CheckCircleOutlined } from '@ant-design/icons';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getAreas, getEstadosGlobales } from 'api/catalogos/index';
import { integerRegExp } from 'utils/patterns';
import ModalConfirmation from 'components/ModalConfirmation';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { getModelPermission } from 'utils/permission';
import { getPuestos } from 'api/estructuraOrganizacional/puestos';
import {
  autorizarCargaReporteXlsReloj,
  deleteCargaReporteXlsReloj,
  getCargaReporteXlsReloj,
  getCargasReportesXlsReloj,
  getCargasReportesXlsRelojPag,
  patchCargaReporteXlsReloj,
  postCargaReporteXlsReloj,
} from 'api/configuraciones/clock/CargaReporteReloj/CargaReporteXlsReloj';
import { getTodosDescuentos } from 'api/catalogos/TodosDescuentos';

import currencyFormatter from 'utils/currencyFormatter';

const CargaReporteXlsReloj = ({
  CargaReportePadre,
  permission,
  registrosCargados = [],
  showParentForm,
  hideParentForm,
  pollingEnCurso = false, //  así se llama el prop
  usarRegistrosLocales = false, // nuevo prop para usar registros locales
}) => {
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open2, setVisible2] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  // const [data, setData] = useState([]);
  const [data, setData] = useState({ results: [], count: 0 });
  const [todosLosRegistros, setTodosLosRegistros] = useState([]);
  const pageSize = 10;
  const [, setConfirmationVisibleEstatus] = useState(false);
  const [estados, setEstados] = useState([]);
  const [tiposempleados, setTiposEmpleados] = useState([]);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [areas, setAreas] = useState([]);
  const [puesto, setPuesto] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [selectedData] = useState({});
  const [pageActual, setPageActual] = useState(1);
  const [descuentos, setDescuentos] = useState([]);
  const [mostrarAlertaLocal, setMostrarAlertaLocal] = useState(false);

  const isEditing = !!CargaReportePadre?.id;

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getCargasReportesXlsReloj({ carga_de_reporte: CargaReportePadre?.id });
    setData(formatReceived(_data));
    setLoading(false);
  };

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getCargasReportesXlsRelojPag({ page: cleanPage, ...q });

      const { results } = _data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const fetchConceptos = async () => {
    if (!descuentos.length) {
      const descuento = await getTodosDescuentos(); // tu API
      setDescuentos(descuento);

      const _estados = await getEstadosGlobales();
      setEstados(_estados);
    }
  };

  const paginarLocalmente = (registros, page) => {
    const desde = (page - 1) * pageSize;
    const hasta = desde + pageSize;
    const currentPageData = registros.slice(desde, hasta);
    setData({ results: currentPageData, count: registros.length });
    setPageActual(page);
  };

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      if (usarRegistrosLocales) return; // ⬅️ no sobrescribas si hay carga local

      setLoading(true);
      await checkToken();

      const [_estados, _data] = await Promise.all([
        getEstadosGlobales(),
        getCargasReportesXlsReloj({ carga_de_reporte: CargaReportePadre?.id }),
      ]);

      // const { results } = _data;

      if (mounted) {
        setEstados(_estados);
        // setData({ ..._data, results });
        setData(_data);
        setLoading(false);
      }
    };

    if (isEditing && CargaReportePadre) {
      fetchAll();
    }

    return () => { mounted = false; };
  }, [CargaReportePadre, isEditing, usarRegistrosLocales]);

  useEffect(() => {
    if (!pollingEnCurso && usarRegistrosLocales) {
      if (registrosCargados?.length > 0) {
        setTodosLosRegistros(registrosCargados);
        paginarLocalmente(registrosCargados, 1);
        setMostrarAlertaLocal(true);
      } else {
        setTodosLosRegistros([]);
        paginarLocalmente([], 1);
        setMostrarAlertaLocal(false);
      }
    }
  }, [registrosCargados, pollingEnCurso, usarRegistrosLocales]);

  useEffect(() => {
    if (!pollingEnCurso || !CargaReportePadre?.id) {
      return () => { }; // retorna función vacía si no hay polling
    }

    const interval = setInterval(() => {
      fetchData();
    }, 5000);

    return () => clearInterval(interval); // función de limpieza cuando se desmonta o cambia
  }, [pollingEnCurso, CargaReportePadre?.id]);

  /*
  const dataNormalizer = (dataArray) => {
    if (!Array.isArray(dataArray)) return [];

    return dataArray.map((row) => {
      const dataToSplit = row.empleado?.numero_y_nombre_completo;

      const [number, completeName] = dataToSplit.split(' - ');

      return {
        ...row,
        numero_de_empleado: number,
        empleado: completeName,
        dia_de_la_semana: row?.dia_de_la_semana?.nombre,
      };
    });
  };
  */

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 100,
    },
    {
      titleText: 'Dia',
      dataIndex: 'dia_semana_nombre',
      key: 'dia_semana_nombre',
      width: 100,
    },
    {
      titleText: 'No. de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 150,
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'nombre_enpleado',
      key: 'nombre_enpleado',
      width: 200,
    },
    {
      titleText: 'Hora de Entrada',
      dataIndex: 'hora_entrada',
      key: 'hora_entrada',
      width: 150,
    },
    {
      titleText: 'Hora de Salida',
      dataIndex: 'hora_salida',
      key: 'hora_salida',
      width: 150,
    },
    {
      titleText: 'Tiempo Trabajado',
      dataIndex: 'tiempo_trabajado',
      key: 'tiempo_trabajado',
      width: 160,
    },
    {
      titleText: 'Resutado',
      dataIndex: 'resultado',
      key: 'resultado',
      width: 160,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading || pollingEnCurso}>
        {mostrarAlertaLocal && (
          <Alert
            message={`Se cargaron ${registrosCargados.length} registros desde el archivo Excel.`}
            type="info"
            showIcon
            closable
            style={{ marginBottom: 16 }}
          />
        )}
        <Table
          cols={columns}
          data={data}
          /** { () => (usarRegistrosLocales
          ? data?.results
          : data
          // dataNormalizer(data?.results).sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
          || []) } */
          rowSelection={rowSelection}
          /** pagination={false}
          paginationCallback={(page) => (usarRegistrosLocales
            ? paginarLocalmente(todosLosRegistros, page)
            : fetchPaginated(page))} */
          /** count={data?.count || 0} */
          handleOnRowClick={handleOnRowClick}
          disableDelete
          permission={permission}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default CargaReporteXlsReloj;
